import { Phone, Clock, CheckCircle2 } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { SiteFooter } from "../components/SiteFooter";
import { PageHero } from "../components/PageHero";
import { PriceBoard } from "../components/PriceBoard";
import { BUSINESS, IMAGES, DOG_WASH, DOG_WASH_HOURS, DOG_WASH_FEATURES } from "../lib/business";

export default function DogWash() {
  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <PageHero testid="dog-wash-hero" eyebrow="Dog Wash" title={<>Clean Car.<br />Clean Dog.</>} image={IMAGES.dogWash}
        text={`Our pay-as-you-go dog wash ${BUSINESS.site.replace("At ", "at ")}. Bring your best mate along while you wash the car.`}>
        <div className="mt-10 flex flex-wrap items-baseline gap-2" data-testid="dog-wash-headline-price">
          <span className="font-head font-black text-5xl text-white">$10</span>
          <span className="overline text-muted-foreground">for 10 min · top up anytime</span>
        </div>
        <div className="mt-4 overline text-volt flex items-center gap-2" data-testid="dog-wash-hours"><Clock className="w-4 h-4" /> {DOG_WASH_HOURS}</div>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 pt-20 grid lg:grid-cols-2 gap-12 items-start">
        <img src={IMAGES.dogWash} alt="K9000 self-service dog wash" data-testid="dog-wash-photo" className="w-full h-[360px] object-cover border border-white/10" />
        <div>
          <div className="overline text-volt mb-3">K9000 Self-Service Dog Wash</div>
          <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-6">Every Wash Includes</h2>
          <div className="border border-white/10">
            {DOG_WASH_FEATURES.map((f) => (
              <div key={f} className="flex items-center gap-3 p-4 border-b border-white/10 last:border-b-0">
                <CheckCircle2 className="w-5 h-5 text-volt shrink-0" />
                <span className="text-sm tracking-wide">{f}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-6 py-20">
        <div className="overline text-volt mb-3">Pricing</div>
        <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-8">Dog Wash Prices</h2>
        <div className="max-w-md"><PriceBoard {...DOG_WASH} testid="dog-wash-board" /></div>
        <a href={BUSINESS.phoneHref} data-testid="dog-wash-call-btn" className="mt-8 inline-flex items-center gap-2 border border-white/20 px-6 py-3 overline hover:border-volt transition-colors">
          <Phone className="w-4 h-4 text-volt" /> Call {BUSINESS.phone}
        </a>
      </section>
      <SiteFooter />
    </div>
  );
}
